import { MyGiftPoints } from "@/components/MyGiftPoints";

export const ComponentTestPage = () => {
  return <MyGiftPoints points={10000} onClickCard={(cardId) => console.log(cardId)} />;
};
